import React, { Component } from "react";
import { FormGroup, Input } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { connect } from "react-redux";

import {
  QuotationChecked,
  ApprovedQuantity,
} from "../../../store/CompareQuotation/actions";
class VendorCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cellValue: VendorCellRenderer.getValueToDisplay(props),
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      cellValue: VendorCellRenderer.getValueToDisplay(nextProps),
    };
  }

  getReactContainerStyle() {
    return {
      //   display: 'inline-block',
      height: "100%",
    };
  }
  getCheckedRequest(e, index, vendorId) {
    this.props.QuotationChecked(e.target.checked, index, vendorId);
  }
  ChangeHandeler(e, index, vendorId) {
    this.props.ApprovedQuantity(e.target.value, index, vendorId);
  }

  render() {
    if (this.state.cellValue != null) {
      if (typeof this.state.cellValue === "string") {
        return (
          <div className="CompareBox">
            <FormGroup className="mb-0">
              <Input
                type="textarea"
                className="form-control"
                placeholder="Enter Terms & Conditions"
                rows="14"
                disabled={true}
                value={this.state.cellValue}
              />
            </FormGroup>{" "}
          </div>
        );
      } else {
        return (
          <div className="CompareBox">
            <AvForm>
              <ul className="list-style-Compare p-0">
                <li className="clearfix">
                  <div className="QuotationCheck">
                    <AvField
                      type="checkbox"
                      name="QuotationCheckbox"
                      value={this.props.value?.Quotationcheck}
                      onChange={(e) => {
                        this.getCheckedRequest(
                          e,
                          this.state.cellValue?.index,
                          this.state.cellValue?.vendorId
                        );
                      }}
                    />
                  </div>
                </li>
                <li className="clearfix mt-3">
                  <span className="ttl">Quantity:</span>
                  <span className="dtl">
                    {this.props.value?.Quantity} {this.props.value?.unit.name}
                  </span>
                </li>
                <li className="clearfix">
                  <span className="ttl">Base Price:</span>
                  <span className="dtl">{this.state.cellValue?.baseprice}</span>
                </li>
                {/* <li className="clearfix">
                  <span className="ttl">Discount (%):</span>
                  <span className="dtl">
                    {this.state.cellValue?.discountpercent} %
                  </span>
                </li> */}
                <li className="clearfix">
                  <span className="ttl">Price (After Discount):</span>
                  <span className="dtl">
                    {this.state.cellValue?.Price} (
                    {this.state.cellValue?.discountpercent}%)
                  </span>
                </li>
                <li className="clearfix">
                  <span className="ttl">Gross Value:</span>
                  <span className="dtl">
                    {this.state.cellValue?.GrossValue}
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Tax :</span>
                  <span className="dtl">
                    {this.state.cellValue?.taxtype === 1
                      ? "Inclusive"
                      : "Exclusive"}{" "}
                    ({this.state.cellValue?.GST})
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">PO Qty:</span>
                  <span className="dtl">
                    {this.state.cellValue?.po_qty} {this.props.value?.unit.name}
                  </span>
                </li>
                <li className="clearfix">
                  <span className="ttl">Tax Amount:</span>
                  <span className="dtl">{this.state.cellValue?.taxamount}</span>
                </li>
                <li className="clearfix mt-2">
                  <span className="ttl">Net Value:</span>
                  <span className="dtl ">
                    {this.state.cellValue?.updateGrossValue}
                  </span>
                </li>
                <li className="clearfix">
                  <span className="ttl">Approved Quantity:</span>
                  <span className="dtl">
                    {this.state.cellValue?.Quotationcheck === true ? (
                      <div className="Quantity-input">
                        <FormGroup className="mb-0 ">
                          <AvField
                            className="pr-0 "
                            placeholder="qty"
                            min={0}
                            max={
                              this.state.cellValue?.Quantity -
                              this.state.cellValue?.po_qty
                            }
                            type="number"
                            // step="1"
                            name="ApprovedQuantity"
                            id="ApprovedQuantity"
                            value={this.state.cellValue?.ApprovedQuantity}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Please enter Qty",
                              },
                              pattern: {
                                value: "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                errorMessage:
                                  "Qty can compose numbers and 3 decimals",
                              },
                            }}
                            onChange={(e) =>
                              this.ChangeHandeler(
                                e,
                                this.state.cellValue?.index,
                                this.state.cellValue?.vendorId
                              )
                            }
                          />
                        </FormGroup>
                      </div>
                    ) : (
                      this.state.cellValue?.ApprovedQuantity
                    )}
                  </span>
                </li>
              </ul>
            </AvForm>
          </div>
        );
      }
    } else {
      return (
        <div className="CompareBox">
          <div className="box-bg" style={{ width: "100%", height: "260px" }}>
            <div class="containerbackground">
              <span className="font-size-20">Not submitted</span>
            </div>
          </div>
        </div>
      );
    }
  }
  static getValueToDisplay(params) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}

export default connect(null, {
  QuotationChecked,
  ApprovedQuantity,
})(VendorCellRenderer);
